import { Injectable } from '@angular/core';
import { collectionData } from '@angular/fire/firestore';
import { getApp } from 'firebase/app';
import { collection, Firestore, getFirestore, query, where } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class ProductosFitosanitariosService {
  firestore: Firestore;


  constructor() {
      this.firestore = getFirestore(getApp('[FITO]'));


  }

  queryProductos(agente: string){
    const collectionReference = query(collection(this.firestore, 'Productos'), where('usosAgentes','array-contains',agente));

    return collectionData(collectionReference);
  }

}
